// DescriptionModal — per-event "About the workshop" rendered from markdown
// (about_md column). Phase 3d-1c moved the structured DESCRIPTION_INTRO /
// DIFFERENTIATORS / ACTIVITIES / TAKEAWAYS / CLOSER constants in
// workshop.ts to per-event markdown text. EventDetailPage hides the
// trigger button when content is empty.

import { Modal } from './Modal';
import { MarkdownBody } from './MarkdownBody';

interface Props {
  open: boolean;
  onClose: () => void;
  content: string;
}

export function DescriptionModal({ open, onClose, content }: Props) {
  return (
    <Modal open={open} onClose={onClose} title="About the workshop" maxWidth="max-w-4xl">
      <div className="space-y-4">
        <MarkdownBody source={content} />
      </div>
    </Modal>
  );
}
